
// export const environment = {
//   production: true,
//   sitioTest: false, // Subir a test: true muestra la marca de agua "ESTE ES UN SITIO DE PRUEBA" en todo el sitio
//   URL_WEB: 'https://www.sorteoanahuac.mx',
//   URL_API_LEGALES: 'https://serviciossitioapp.sorteoanahuac.mx',
//   URL_MICROSITIO: 'https://sorteoanahuaccompra.sorteoanahuac.mx',
//   URL_API_MAGNO: 'https://serviciosapp.sorteoanahuac.mx',
//   URL_MICROSITIO_ANIV: '',
//   URL_API_ANIV: '',
//   ts: 'dDBrM25EM1MzZ1U3SWRARDlAclFTM3ZpQzAyJCUjQTlJcyRlIzNQNXIwZFU1NTFPbmMyMXNUM200YXM=',
// };




// export const environment = {
//   production: false,
//   sitioTest: false, // Subir a test: true muestra la marca de agua "ESTE ES UN SITIO DE PRUEBA" en todo el sitio
//   URL_WEB: 'https://qasitio.sorteoanahuac.mx/',
//   URL_API_LEGALES: 'https://qaserviciosapp.sorteoanahuac.mx/',
//   URL_MICROSITIO: 'https://qapago.sorteoanahuac.mx/',
//   URL_API_MAGNO: 'https://qaserviciosapp.sorteoanahuac.mx/',
//   URL_MICROSITIO_ANIV: '',
//   URL_API_ANIV: '',
//   ts: 'TDBHNjNuczNDdVIxVDNUQCNLM05CVFIqMjI0JTUzYzgzVA',
 
//   //TDBHNjNuczNDdVIxVDNUQCNLM05CVFIqMjI0JTUzYzgzVA==
//   //GCSaTPT6rUlfbDAriV5i4kIoS0w0d3oCXAh6v
// };


export const environment = {
  production: false,
  sitioTest: true, // Subir a test: true muestra la marca de agua "ESTE ES UN SITIO DE PRUEBA" en todo el sitio
  URL_WEB: 'https://testsitio.sorteoanahuac.mx/',
  URL_API_LEGALES: 'https://testserviciosapp.sorteoanahuac.mx/',
  URL_MICROSITIO: 'https://testpago.sorteoanahuac.mx/',
  URL_API_MAGNO: 'https://testserviciosapp.sorteoanahuac.mx/',
  URL_MICROSITIO_ANIV: '',
  URL_API_ANIV: '',
  ts: 'TDBHNjNuczNDdVIxVDNUQCNLM05CVFIqMjI0JTUzYzgzVA',
 
  //TDBHNjNuczNDdVIxVDNUQCNLM05CVFIqMjI0JTUzYzgzVA==
  //GCSaTPT6rUlfbDAriV5i4kIoS0w0d3oCXAh6v
};